import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_list",
  "use": "icon-map_list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_list\">\n<g id=\"icon-map_list_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 1 1 L 1 4 L 4 4 L 4 1 L 1 1 M 7.175781 2 C 5.453125 3.601563 12.425781 4.519531 13.824219 3.121094 C 15.546875 1.398438 8.574219 0.480469 7.175781 2 M 1 6 L 1 9 L 4 9 L 4 6 L 1 6 M 7.175781 7 C 5.453125 8.601563 12.425781 9.519531 13.824219 8.121094 C 15.546875 6.398438 8.574219 5.480469 7.175781 7 M 1 11 L 1 14 L 4 14 L 4 11 L 1 11 M 7.175781 12 C 5.453125 13.601563 12.425781 14.519531 13.824219 13.121094 C 15.546875 11.398438 8.574219 10.480469 7.175781 12 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_list.svg
// module id = JNfX
// module chunks = 24